import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { SROnlyH1 } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function MonkeyAlternative() {
  return (
    <>
      <SEO
        title="Monkey App Alternative - Talkvee Random Video Chat"
        description="The best Monkey App alternative for random video chat. Talkvee is safer, cleaner, and works instantly in your browser with no download required."
        pathname="/monkey-app-alternative"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Monkey App Alternative", "item": "https://talkvee.com/monkey-app-alternative" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <div className="landing-banner">
          <strong>Monkey App Alternative</strong> — Safer, faster, and no app download required.
        </div>

        <section className="landing-hero">
          <h1 className="landing-title">The Safer Monkey App Alternative</h1>
          <p className="landing-subtitle">
            Looking for the Monkey App vibe but safer and without the app store hassle? 
            Talkvee connects you instantly for random video chats and fun challenges.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>

        <FAQSection
          items={[
            {
              q: "Is Talkvee like the Monkey App?",
              a: "Yes, it connects you randomly with strangers for video chat, but Talkvee adds games and focuses more on safety."
            },
            {
              q: "Why use Talkvee instead of Monkey?",
              a: "Monkey has had safety issues in the past. Talkvee is built with modern safety tools, strict moderation, and no invasive tracking."
            },
            {
              q: "Can I use it on TikTok style view?",
              a: "We are launching VeeClips soon, which will bring that vertical scrolling video feed experience you love."
            }
          ]}
        />
      </div>
    </>
  );
}